import AccessoryPC from './pc';
import AccessoryMO from './mo';
import { useGetConfig } from '../../useGetConfig';

/**
 * @description 套餐配件模块
 */
export default function AccessoryCarousel() {
  const {
    mobxStore: { app },
  } = useGetConfig();
  const { isMobile } = app;

  return isMobile ? <AccessoryMO /> : <AccessoryPC />;
}
